// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__l6mCK","title":"BackImages_title__1QVGI","images":"BackImages_images__3RcGC"};